import React from 'react'
import PropTypes from 'prop-types'
import PerformanceItem from '../PerformanceItem'

function UserCountModal() {
	return (
		<div className='performance_item_modal user_count_modal'>
			<h3>User Count</h3>
			<p>
				Large brands now have an average of 6.1 unique companies working on a single campaign—that&apos;s a lot of possibility for complexity!
			</p>
			<p>
				Keeping ad accounts to less than 3 users keeps complications low.
			</p>
			<p>
				If you are in a situation where there has to be multiple teams on a campaign, consider plugging your data into a platform that can ensure everyone is on the same page, sees the same data and can have clear dialogue about performance.
			</p>
		</div>
	)
}

const renderUserCountBody = (value) => {
	return (
		<p>You have {value} ad account managers. Keeping this number low limits undesired complexity.</p>
	)
}

// "userCount":{"score":11,"maxScore":11,"value":1,"benchmark":3}
function UserCountPerformanceItem(props) {
	const { score, maxScore, value } = props.apiScore

	return (
		<PerformanceItem
			title="User Count"
			score={score}
			maxScore={maxScore}
			showPerformanceModal={() => { props.showPerformanceModal('users') }}>
			{renderUserCountBody(value)}
		</PerformanceItem>
	)
}

UserCountPerformanceItem.propTypes = {
	apiScore: PropTypes.object,
	showPerformanceModal: PropTypes.func
}

export {UserCountModal, UserCountPerformanceItem}


// WEBPACK FOOTER //
// ./src/containers/ReportLoaderTopLeads/components/performance_items/UserCount.js